<template>
  <div>
    <article>
      <header>
        <h2>Kontingente</h2>
      </header>
      <main>
        <div class="quota" v-for="quota in quotas">
          <h3>{{ quota.name }}</h3>
          <progress-bar
            v-if="quota.size !== null"
            :max="quota.size"
            :current="quota.size - quota.available_number"
          />
          <p v-if="quota.size !== null">
            {{ quota.size - quota.available_number }}/{{ quota.size }} Tickets
            verkauft
          </p>
          <p v-else>Unbegrenzt</p>
        </div>
      </main>
    </article>
  </div>
</template>
<script>
import adminRequest from "@/mixins/admin-request";
import ProgressBar from "@/components/progress-bar";

export default {
  mixins: [adminRequest],
  components: { ProgressBar },
  data() {
    return {
      quotas: [],
    };
  },
  computed: {},
  mounted() {
    this.loadQuotas();
  },
  methods: {
    loadQuotas() {
      // Todo: Fetch more entries if exceeding page size
      this.adminRequest(
        {
          method: "get",
        },
        "admin/quotas/availability",
        (res) => {
          this.quotas = res.data["results"];
        }
      );
    },
  },
};
</script>
<style scoped lang="scss">
div.quota {
  background: rgba(black, 0.2);
  padding: 20px;
  margin: 1em 0;
}
</style>
